'use client';

import { useQuery } from '@tanstack/react-query';
import { GETAIGCHot } from '@fe-news/api/ai';
import Error from '@fe-news/components/atoms/AsideAiNews/Error';
import Loading from '@fe-news/components/atoms/AsideAiNews/Loading';
import AiGcTitle from '@fe-news/components/atoms/AsideAiNews/AiGcTitle';

type AiGcProps = {
  isAiGc?: boolean;
};

const AiGc = ({ isAiGc }: AiGcProps) => {
  const { data, isError, isFetching } = useQuery({
    queryKey: ['ai-news'],
    queryFn: () => GETAIGCHot()
  });

  const hotQa = data?.hotQa;

  if (isFetching) {
    return <Loading />;
  }

  return (
    <>
      {isError || (!hotQa && <Error />)}
      {!isError && hotQa && (
        <>
          {hotQa.slice(0, isAiGc ? 5 : 4).map((item, index) => (
            <AiGcTitle key={item.question} title={item.question} url={item.link} index={index} isAiGc={isAiGc} />
          ))}
        </>
      )}
    </>
  );
};

export default AiGc;
